<template>
  <div class="laureatGroup" :class="{active: active, inview: inview, show: show, lastOne: index === total - 1}" ref="group">
    <div class="laureatGroupOuter" ref="groupOuter">
      <div class="laureatGroupInner" @click="openCard" ref="groupInner" :class="{link: !active}">
        <div class="laureatGroupInnerInner">
          <div class="top">
            <div class="upper">
              <div class="title"><span v-html="card"></span></div>
              <div class="close hideMenu link" @click.stop="closeCard">
                <div class="closeInner">&times;</div>
              </div>
            </div>

            <div class="lower desc" v-if="view === 'prix'">
              <span v-html="prixDesc.description"></span>
            </div>
          </div>

          <div class="laureatContainer">
            <Laureat v-for="(item, index) in randOrd" :item="item" :key="item.title + index"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Laureat from '@/components/Laureat.vue'
import setLaureat from '@/components/setLaureat'

export default {
  data () {
    return {
      load: false,
      active: false,
      show: false,
      inview: false,
      observer: false,
      visiblep: '45deg',
      check: false
    }
  },

  components: {
    Laureat
  },

  mixins: [setLaureat],

  props: ['card', 'index', 'total', 'view'],

  computed: {
    prixDesc () {
      return this.$store.getters.prix(this.card)
    },

    start () {
      if (this.index === this.currOpen) {
        return true
      } else {
        return false
      }
    },

    current () {
      return this.$store.getters.all.filter(item => item[this.view].title === this.card)
    },

    randOrd () {
      let current = this.current
      // Set size and randomize project order
      let j
      let x
      let i

      for (i = 0; i < current.length; i++) {
        x = current[i]
        j = Math.floor(Math.random() * (i + 1))
        current[i] = current[j]
        current[j] = x
      }

      current.forEach((item, index) => {
        this.setLaureat(item, index, current)
      })

      let nArr = []
      current.forEach((item, index) => {
        if (item.col === 2) {
          nArr.splice(index - 1, 0, item)
        } else {
          nArr.push(item)
        }
      })

      return nArr
    }
  },

  methods: {
    openCard () {
      if (!this.active) {
        this.$emit('setSelectedOpen')
        this.$store.commit('editState', { state: 'currentLoop', data: this.randOrd })

        this.$nextTick(() => {
          this.show = true

          this.active = true
          this.$store.commit('editState', { state: 'cardOpen', data: true })

          let card = this.$refs.group
          let innerCard = this.$refs.groupOuter
          let cardPos = card.getBoundingClientRect()

          innerCard.style.position = 'fixed'
          innerCard.style.top = cardPos.top + 'px'
          innerCard.getBoundingClientRect()

          innerCard.style.top = '0'
          innerCard.getBoundingClientRect()
        })
      }
    },

    mount () {
      this.$refs.groupOuter.addEventListener('transitionend', (e) => {
        if (e.target === this.$refs.groupOuter) {
          if (e.propertyName === 'top' && !this.active) {
            let innerCard = this.$refs.groupOuter

            innerCard.style.position = ''
            innerCard.style.top = ''
            this.inview = false
            this.show = false
          }

          if (e.propertyName === 'top' && this.active) {
            this.inview = true
            this.$nextTick(() => {
              this.$store.commit('editState', { state: 'cardActive', data: true })
            })
          }
        }
      })
    },

    closeCard () {
      // Close card, enable body scroll
      this.active = false
      this.$store.commit('editState', { state: 'cardOpen', data: false })
      this.$store.commit('editState', { state: 'cardActive', data: false })

      this.$nextTick(() => {
        this.$emit('closeSelected')
        let card = this.$refs.group
        let innerCard = this.$refs.groupOuter
        let cardPos = card.getBoundingClientRect()

        innerCard.style.top = cardPos.top + 'px'
        innerCard.getBoundingClientRect()
      })
    }
  },

  mounted () {
    this.mount()
    if (this.index === this.total - 1) this.$emit('last')
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.laureatGroup {
  position: relative;
  width: 100%;
  height: calc(4.5rem - 2px);
  overflow: visible;
  margin-top: 0;
  transition: margin-bottom $ease ease;

  .top {
    padding: 0 $side;
  }

  .laureatContainer {
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  .upper {
    cursor: pointer;
  }
}

.cardActive .laureatGroup {
  display: none;
}

.cardActive .laureatGroup.active {
  display: block;
}

.laureatGroupOuter {
  perspective: 100rem;
  padding-bottom: 65rem;
  width: 100%;
  position: relative;
  transition: top $ease ease;
  transform: translate3d(0,0,0);
}

.laureatGroupInner {
  position: absolute;
  left: 0;
  top: -9.5rem;
  width: 100%;
  height: 100%;
  overflow: visible;
  background-color: white;
  transform: translateZ(-23rem) rotateX(-45deg);
  pointer-events: auto;
  transition: transform $ease ease, top $ease ease;
}

.laureatGroupInnerInner {
  position: relative;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  border: 1px solid;
  transition: border $ease ease;
  box-shadow: 0px -6px 8px -5px rgba(0, 0, 0, 0.8);
}

.hideMenu {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.open .laureatGroup.inview .hideMenu {
  opacity: 1;
}

.active.inview {
  .laureatGroupOuter {
    padding-bottom: 0;
    bottom: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    perspective: none;
  }

  .laureatContainer {
    pointer-events: auto;
  }

  .laureatGroupInner {
    overflow: visible;
    height: auto;
  }

  .laureatGroupInnerInner {
    max-height: auto;
    overflow: visible;
    box-shadow: none;
  }

  .upper {
    background-color: white;
  }
}

.lg .laureatGroup:hover {
  .laureatGroupInner {
    transform: translate3d(0, -2rem, -23rem) rotateX(-45deg);
  }

  .laureatContainer {
    opacity: 1;
  }
}

.active {
  &.laureatGroup {
    margin-bottom: calc(var(--vh, 1vh) * 100 - 5rem);

    .upper {
      cursor: auto;
    }
  }

  .laureatGroupInner {
    top: 0;
    transform: translate3d(0, 0, 0) rotateX(0deg) !important;
  }

  .laureatGroupInnerInner {
    border: 1px solid transparent;
  }
}

.laureatGroup.lastOne,
.show {
  .laureatContainer {
    opacity: 1;
  }
}

.desc {
  text-align: left;
}
</style>
